import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, commonIdFindUniversitiesFeatureKey } from '../../reducers/common-id/common-id-find-universities.reducer';

const selectCommonIdFindUniversitiesState = createFeatureSelector<State>(commonIdFindUniversitiesFeatureKey);

export const getCommonIdFindUniversitiesResult = createSelector(selectCommonIdFindUniversitiesState, state => state.result);
